import React, { useState } from 'react';
import LeadDialog from './LeadDialog';
import { handleValidateCodevalue } from '../Utility/constant';
import { useDispatch } from 'react-redux';
import AutoCompleteComponent from './AutoCompleteComponenet';
import { StyledLeadContainer } from './Styled';
import { requestShowDialogLoader, requestHideDialogLoader } from '../Store/Global/action';
import InfoIcon from './Widgets/InfoIcon';
import { updateRequestData } from '../Utility/apiHelper';
const CommonBulkUpdate = ({
    size,
    open,
    handleClose,
    title,
    selectionModel,
    fieldsData,
    handleSearch,
    enqueueSnackbar,
    internationalise,
}) => {
    const dispatch = useDispatch();

    const [bulkUpdateData, setBulkUpdateData] = useState({});

    const handleFieldChange = (fieldName, value) => {
        setBulkUpdateData((prev) => ({
            ...prev,
            [fieldName]: value,
        }));
    };

    const handleSave = async () => {
       
        const fieldPayload = {};
        Object.entries(bulkUpdateData).forEach(([key, value]) => {
            if (value && value.name) {
                fieldPayload[key] = value.name;
            }
        });

        if (Object.keys(fieldPayload).length === 0) {
            enqueueSnackbar(
                handleValidateCodevalue(internationalise, 'COMMON_SELECT_ONE_FIELD_WARNING'),
                { variant: 'warning' }
            );
            return;
        }

        const payload = {
            leadIds: selectionModel,
            ...fieldPayload,
        };

        dispatch(requestShowDialogLoader());
        try {
            const url = "leads/bulk-update";
            const response = await updateRequestData(payload,url)
            const data = response?.data;
            const error = response?.propererror?.data;
            if(response?.status !== 200){
                enqueueSnackbar(
                `${error?.failed} ${handleValidateCodevalue(internationalise, error?.summary)}`,
                { variant: 'error' }
            );
            handleClose();
            return;
        }
            enqueueSnackbar(
                `${data?.success} ${handleValidateCodevalue(internationalise, data?.summary)}`,
                { variant: 'success' }
            );

            setBulkUpdateData({});
            handleClose();
            if (handleSearch) handleSearch();
        } catch (error) {
            const summary = error?.response?.data?.summary;
            enqueueSnackbar(
                handleValidateCodevalue(internationalise, summary || 'COMMON_PLEASE_TRY_AGAIN'),
                { variant: 'error' }
            );
        } finally {
            dispatch(requestHideDialogLoader());
        }
    };

    const handleDialogClose = () => {
        setBulkUpdateData({});
        handleClose();
    };

    return (
        <LeadDialog
            open={open}
            handleClose={handleDialogClose}
            title={title}
            size={size}
            btnlabel={handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
            handleSave={handleSave}
        >
            
            <InfoIcon
                text = "BULK_UPDATE_INFO"
            /> 
            <StyledLeadContainer sx={{ columnGap: 4 }}>
                {fieldsData?.map((field) => (
                    <AutoCompleteComponent
                        isLookup={true}
                        key={field.name}
                        sx={{width:"30%"}}
                        label={handleValidateCodevalue(internationalise,field.label)}
                        optionSet={field.options || []}
                        value={bulkUpdateData[field.name] || null}
                        onChange={(event, value) => handleFieldChange(field.name, value)}
                    />
                ))}
            </StyledLeadContainer>
        </LeadDialog>
    );
};

export default CommonBulkUpdate;